import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const consecutiveSpacesRegex = new RegExp(/ {2,}/);
const leadingTrailingSpacesRegex = new RegExp(/^ | $/);

const schema = {
	'displayName': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['displayName']) {
			if (value.length < 4) {
				return localize('company-profile-team-name-length');
			}
			if (consecutiveSpacesRegex.test(value)) {
				return localize('company-profile-team-name-consecutive-spaces');
			}
			if (leadingTrailingSpacesRegex.test(value)) {
				return localize('company-profile-team-name-leading-trailing-spaces');
			}
		}
	},
	'language': null,
	'email': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['email'] && !isEmail(value)) {
			return localize('company-profile-email-invalid');
		}
	},
	'address1': null,
	'address2': null,
	'city': null,
	'region': null,
	'postcode': null,
	'country': (value, state, props) => {
		if (value && state.touched['country'] && props.companyCountries.indexOf(value) === -1) {
			return localize('company-profile-country-invalid');
		}
	},
	'phone': (value) => {
		// eslint-disable-next-line no-useless-escape
		if (value && value.match(/^[0-9\-\+\(\)\s]*$/) === null) {
			return localize('company-profile-phone-invalid');
		}
	},
	'website': (value, state) => {
		if (value && state.touched['website'] && !isURL(value, { protocols: ['http','https'], require_protocol: true})) {
			return localize('company-profile-website-invalid');
		}
	},
	'industry': (value, state, props) => {
		let industryDisplayNames = props.companyIndustries.map(industry => industry.displayName);
		if (value && state.touched['industry'] && industryDisplayNames.indexOf(value) === -1) {
			return localize('company-profile-industry-invalid');
		}
	},
	'size': null
	
};

export default schema;


// WEBPACK FOOTER //
// ./src/containers/CompanyProfile/CompanyProfileSchema.js